import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { askDestination, bareAskDestination, utmOf } from '../utils/askLink';
import { track, EVENTS } from '../services/analytics';

// /ask/<short> (#3262; founder pick 1b-A of the Astra entry mocks,
// 2026-10-06): the short link a Short's end card prints (/ask/ucla). It is
// never a page of its own: it forwards to the school's canonical college page
// with #ask, which opens Astra's sheet there, keeping only the utm fields. An
// unknown short name goes to the /colleges search for it, never a guessed
// school (product invariant 5). Hosting serves /ask/* the noindex app shell
// and the college page names its own canonical, so there is no duplicate page.
//
// ask_link_landed {short, school_id, resolved, utm_*}: a typed link arrives
// with no utm, which is itself the sign it came off an end card.
//
// The bare /ask (#5267, `bare`): Astra on the home page, ask_link_landed
// {short: null, bare: true}.
export default function AskRedirect({ bare = false }) {
    const { short } = useParams();
    const { search } = useLocation();
    const dest = bare ? bareAskDestination(search) : askDestination(short, search);
    // The event goes first, while the address bar still reads /ask/<short>.
    const [go, setGo] = useState(false);
    useEffect(() => {
        track(EVENTS.ASK_LINK_LANDED, {
            // an unknown short is never sent: it is whatever was typed
            short: dest.slug ? String(short || '').toLowerCase().slice(0, 60) : null, slug: dest.slug,
            resolved: Boolean(dest.slug), ...(bare ? { bare: true } : {}), ...utmOf(search),
        });
        setGo(true);
    }, []);   // eslint-disable-line react-hooks/exhaustive-deps
    if (!go) return null;
    return <Navigate to={dest.to} replace state={dest.slug ? { askLink: true } : null} />;
}
